import reactLogo from '../assets/skills-logos/react.png';
import reactNLogo from '../assets/skills-logos/reactjsBlack.jpg';
import nodejsLogo from '../assets/skills-logos/nodejs.png';
import javaScriptLogo from '../assets/skills-logos/logojs.png';
import javalogo from '../assets/skills-logos/java-logo-s.jpg';
import angularjsLogo from '../assets/skills-logos/angularjs.jpg';
import angularLogo from '../assets/skills-logos/angular.png';
import swiftLogo from '../assets/skills-logos/swift-logo.png';
import htmlLogo from '../assets/skills-logos/htmlLogo.jpg';
import cssLogo from '../assets/skills-logos/css-logo-s.jpg';
import kotlinLogo from '../assets/skills-logos/kotlin-logo.png';
import pythonLogo from '../assets/skills-logos/python-logo.png';
import figmaLogo from '../assets/skills-logos/figma-logo.png';
import adobeXdLogo from '../assets/skills-logos/adobe-xd-logo.png';
import githubLogo from '../assets/skills-logos/github-circle-logo.svg';
import dockerLogo from '../assets/skills-logos/dockerlogo.png';
import awsLogo from '../assets/skills-logos/aws-logo.png';

export const frontendSkills = [
    {
      name:'React.js',
      logo: reactLogo
    },
    {
      name:'React Native',
      logo: reactNLogo
    }, 
    {
        name:'Angular',
        logo: angularLogo
      }, 
    {
      name:'JavaScript',
      logo: javaScriptLogo
    }, 
    {
      name:'Angular.js',
      logo: angularjsLogo
    }, 
    {
      name:'HTML',
      logo: htmlLogo
    }, 
    {
      name:'CSS',
      logo : cssLogo
    },
  ];

  
export const backendSkills = [
  
  {
    name:'Node.js',
    logo: nodejsLogo
  }, 
  { 
      name:'Java', 
      logo: javalogo
  },
  { 
      name:'Swift', 
      logo: swiftLogo
  },
  { 
      name:'Python', 
      logo: pythonLogo
  },
  { 
      name:'Kotlin', 
      logo: kotlinLogo
  },  
];

export const designSkills =[
  { 
    name:'Figma', 
    logo: figmaLogo
},
{ 
    name:'Adobe XD', 
    logo: adobeXdLogo
},
];

export const otherSkills =[
{ 
    name:'Github', 
    logo: githubLogo
},
{ 
    name:'Docker', 
    logo: dockerLogo
},
{ 
  name:'AWS', 
  logo: awsLogo
},
];
